<!-- 批量生成溯源码 -->
<template>
    <div class="container">
        <div class="content">
            <div class="display_flex">
                <div class="flex-c flex-column card mr-24" @click="goModal(4)">
                    <div class="p1">通用行业</div>
                    <div class="p2">全行业通用型批量生码模块</div>
                    <div class="p3">点击进入批量生码操作</div>
                </div>
                <div class="flex-c flex-column card" @click="goModal(5)">
                    <div class="p1">农药行业</div>
                    <div class="p2">农药专用批量生码模块</div>
                    <div class="p3">点击进入批量生码操作</div>
                </div>
            </div>
        </div>
        <!-- 批量生成溯源码（通用行业）/批量生成溯源码（农药行业） -->
        <Modal v-model="modals" :title="modalTitle" :width="modalWidth" :mask-closable="false">
            <div>
                <Form :model="formData" label-position="right" :label-width="150">
                    <FormItem label="选择关联批次：">
                        <Select class="w200" v-model="formData.batch_id" clearable filterable placeholder="请选择">
                            <Option v-for="item in batchList" :value="item.id" :key="item.id">{{ item.batch_name }}</Option>
                        </Select>
                        <Tooltip max-width="250" placement="right" theme="light">
                            <Icon class="cursor-p ml-24" type="md-help-circle" size="20" color="#FF4838"/>
                            <div slot="content"><p>选择批次,没有请先在【批次管理】中【新增批次】</p></div>
                        </Tooltip>
                    </FormItem>
                    <FormItem label="选择关联产品：">
                        <Select class="w200" v-model="formData.product_id" clearable filterable placeholder="请选择">
                            <Option v-for="item in productList" :value="item.id" :key="item.id">{{ item.product_name }}</Option>
                        </Select>
                        <Tooltip max-width="250" placement="right" theme="light">
                            <Icon class="cursor-p ml-24" type="md-help-circle" size="20" color="#FF4838"/>
                            <div slot="content"><p>选择关联的产品,生成后可批量修改更换</p></div>
                        </Tooltip>
                    </FormItem>
                    <FormItem label="选择所属代理商：">
                        <Select class="w200" v-model="formData.agent_id" clearable filterable placeholder="请选择">
                            <Option v-for="item in agentList" :value="item.id" :key="item.id">{{ item.agent_name }}</Option>
                        </Select>
                        <Tooltip max-width="250" placement="right" theme="light">
                            <Icon class="cursor-p ml-24" type="md-help-circle" size="20" color="#FF4838"/>
                            <div slot="content"><p>选择默认所属的代理商,不选则暂时为空</p></div>
                        </Tooltip>
                    </FormItem>
                    <FormItem v-if="modalID == 4 || modalID == 5" label="生成数量：">
                        <Input class="w200" type="text" v-model="formData.qrcode_count" placeholder="建议单次2000条以内"></Input>
                        <Tooltip max-width="250" placement="right" theme="light">
                            <Icon class="cursor-p ml-24" type="md-help-circle" size="20" color="#FF4838"/>
                            <div slot="content"><p>不得超过当前账号所剩数量</p></div>
                        </Tooltip>
                    </FormItem>
                    <FormItem v-if="modalID == 4" label="溯源码长度：">
                        <Input class="w200" type="text" v-model="formData.qrcode_length" placeholder="请填写16-30位数字"></Input>
                        <Tooltip max-width="250" placement="right" theme="light">
                            <Icon class="cursor-p ml-24" type="md-help-circle" size="20" color="#FF4838"/>
                            <div slot="content"><p>溯源码长度=前缀位数+随机码的位数+后缀位数,请填写16-30位数字</p></div>
                        </Tooltip>
                    </FormItem>
                    <FormItem v-if="modalID == 4" label="溯源码前缀：">
                        <Input class="w200" type="text" v-model="formData.qrcode_prefix" placeholder="6个字符以内"></Input>
                        <Tooltip max-width="250" placement="right" theme="light">
                            <Icon class="cursor-p ml-24" type="md-help-circle" size="20" color="#FF4838"/>
                            <div slot="content"><p>前缀可用于溯源码有特殊指定规则的场景(选填)</p></div>
                        </Tooltip>
                    </FormItem>
                    <FormItem v-if="modalID == 5" label="溯源码前缀：">
                        <Poptip trigger="focus">
                            <Input class="width_30" v-model="itemData.prefix1" maxlength="1" placeholder=""/>
                            <div slot="content">按关联农药产品的登记证填写:<br>PD填写1,WP填写2,临时填写3</div>
                        </Poptip>
                        <Poptip trigger="focus">
                            <Input class="width_66" v-model="itemData.prefix2" maxlength="6" placeholder=""/>
                            <div slot="content">填写关联农药产品登记证后六位数字<br>登记证号不足六位数字请至中国农药信息网查询</div>
                        </Poptip>
                        <Poptip trigger="focus">
                            <Input class="width_30 ml-12" v-model="itemData.prefix3" maxlength="1" placeholder=""/>
                            <div slot="content">按关联农药产品的生产类型填写:<br>农药登记证持有人生产填写1,委托加工填写2,委托分装填写3</div>
                        </Poptip>
                        <Poptip trigger="focus">
                            <Input class="width_50 ml-12" v-model="itemData.prefix4" maxlength="3" placeholder=""/>
                            <div slot="content">填写三位企业自制码,如产品规则为150mg,则填写150</div>
                        </Poptip>
                        <Tooltip max-width="250" placement="right" theme="light">
                            <Icon class="cursor-p ml-24" type="md-help-circle" size="20" color="#FF4838"/>
                            <div slot="content"><p>请根据农药溯源码规则填写,并仔细校验是否正确</p></div>
                        </Tooltip>
                    </FormItem>
                    <FormItem v-if="modalID == 4" label="溯源码后缀：">
                        <Input class="w200" type="text" v-model="formData.qrcode_suffix" placeholder="6个字符以内"></Input>
                        <Tooltip max-width="250" placement="right" theme="light">
                            <Icon class="cursor-p ml-24" type="md-help-circle" size="20" color="#FF4838"/>
                            <div slot="content"><p>后缀可用于溯源码有特殊指定规则的场景(选填)</p></div>
                        </Tooltip>
                    </FormItem>
                    <FormItem v-if="modalID == 4"  label="溯源码类型：">
                        <Select class="w200" v-model="formData.qrcode_type" clearable filterable placeholder="请选择">
                            <Option v-for="item in typeList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem v-if="modalID == 4" label="生产时间：">
                        <DatePicker class="w200" :value="formData.productive_time" type="date"  placeholder="点击选择时间" @on-change="changeProductiveTime"></DatePicker>
                    </FormItem>
                    <FormItem v-if="modalID == 4" label="过期时间：">
                        <DatePicker class="w200" :value="formData.expiration_date" type="date" placeholder="点击选择时间" @on-change="changeExpirationDate"></DatePicker>
                    </FormItem>
                    <FormItem v-if="modalID == 4 || modalID == 5" label="是否启用：">
                        <i-switch v-model="formData.status" size="large" true-color="#FF761D" :true-value="1" :false-value="2">
                            <span slot="open">开启</span>
                            <span slot="close">关闭</span>
                        </i-switch>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button class="theme-bc" type="warning" :disabled="!isClickable" @click="submitModal">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import { 
    qrcode_count_create,
} from '@/api/index';
import { product_select, batch_select, agent_select } from '@/api/select';
export default {
    data() {
        return {
            modals: false,
            modalID: "",
            modalTitle: "",
            modalWidth: "",
            formData: {
                batch_id: "",
                product_id: "",
                agent_id: "",
                status: 1,
                qrcode_count: "",
                qrcode_length: "",
                qrcode_prefix: "",
                qrcode_suffix: "",
                qrcode_type: 3,
                productive_time: "",
                expiration_date: "",
                type: "",
            },
            batchList: [],
            productList: [],
            agentList: [],
            typeList: [
                { id: 1, name: "前缀+英文字母(大小写混合)+数字+后缀" },
                { id: 2, name: "前缀+英文字母(大小写混合)+后缀" },
                { id: 3, name: "前缀+纯数字+后缀" },
                { id: 4, name: "前缀+英文字母(大写)+数字+后缀" },
                { id: 5, name: "前缀+英文字母(大写)+后缀" },
            ],
            itemData: { 
                prefix1: "",
                prefix2: "",
                prefix3: "",
                prefix4: "",
            },
            isClickable: true
        };
    },
    mounted() {
        this.getProductSelect();
        this.getBatchSelect();
        this.getagentSelect();
    },
    methods: {
        changeProductiveTime(e){
            if(e){
                this.formData.productive_time = e;
            }else {
                this.formData.productive_time = '';
            }
        },
        changeExpirationDate(e){
            if(e){
                this.formData.expiration_date = e;
            }else {
                this.formData.expiration_date = '';
            }
        },
        goModal(index){
            this.modalID = index;
            if (index == 4){
                this.modalTitle = '批量生成溯源码（通用行业）';
                this.modalWidth = 600;
                this.formData.type = 1;
                this.formData.batch_id = "";
                this.formData.product_id = "";
                this.formData.agent_id = "";
                this.formData.status = 1;
                this.formData.qrcode_count = "";
                this.formData.qrcode_length = 16;
                this.formData.qrcode_prefix = "";
                this.formData.qrcode_suffix = "";
                this.formData.qrcode_type = 3;
                this.formData.productive_time = "";
                this.formData.expiration_date = "";
            }else if (index == 5){
                this.modalTitle = '批量生成溯源码（农药行业）';
                this.modalWidth = 600;
                this.formData.type = 2;
                this.formData.qrcode_length = 32;
                this.formData.qrcode_type = 3;
                this.formData.batch_id = "";
                this.formData.product_id = "";
                this.formData.agent_id = "";
                this.formData.status = 1;
                this.formData.qrcode_count = "";
                this.formData.qrcode_prefix = "";
                this.formData.qrcode_suffix = "";
                this.formData.productive_time = "";
                this.formData.expiration_date = "";
            }
            this.modals = true;
        },
        // 下拉
        getProductSelect(){
            product_select().then((res) => {
                this.productList = res.data;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        getBatchSelect(){
            batch_select().then((res) => {
                this.batchList = res.data;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        getagentSelect(){
            agent_select().then((res) => {
                this.agentList = res.data;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        cancelModal(){
            this.modals = false;
        },
        submitModal(){
            if (this.isClickable) {
                this.isClickable = false;
                setTimeout(() => {
                    this.isClickable = true;
                }, 1000);
                if(this.modalID == 4){
                    var data = Number(this.formData.qrcode_length);
                    if(data < 16 || data > 30){
                        this.$Message.error("请填写16-30位数字");
                        return;
                    }
                    var data2 = this.formData.qrcode_prefix
                    if (data2.length > 6) {
                        this.$Message.error("请填写6个字符以内");
                        return;
                    }
                }
                if(this.modalID == 5){
                    this.formData.qrcode_prefix = this.itemData.prefix1 + this.itemData.prefix2 + this.itemData.prefix3 + this.itemData.prefix4;
                }
                const count = Number(this.formData.qrcode_count);
                if (typeof count != 'number' || isNaN(count)) {
                    this.$Message.error("请填写生成数量数字");
                    return;
                }
                qrcode_count_create(this.formData).then(res=>{
                    this.modals = false;
                    this.$Message.success(res.msg);
                }).catch(res=>{
                    this.$Message.error(res.msg);
                })
            }
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.card {
    padding: 50px;
    background: #FFFFFF;
    box-shadow: 0px 0px 7px 0px rgba(82,102,136,0.32);
    border-radius: 5px;
    border: 1px solid #E5E5E5;
    width: 300px;
    cursor: pointer;
}
.display_flex {
    display: flex;
}
.p1 {
    font-size: 20px;
    color: #484E66;
    font-weight: bold;
}
.p2 {
    margin: 12px 0 24px 0;
}
.p3 {
    cursor: pointer;
    color: #53C41A;
}
.width_30 {
    width: 30px;
}
.width_66 {
    margin: 0 0 0 12px;
    width: 66px;
}
.width_50 {
    width: 50px;
}
.flex-column {
    flex-direction: column !important;
}
</style>